import BookingRewardsView from './BookingRewardsView';

export default BookingRewardsView;
